import React, { useState } from "react";
import PropTypes from "prop-types";
import { trackCallbackMarketplace, trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import FormAddress from "./formAddress";

export default function AddressComponent({ onCancel, onConfirm, address }) {

  function formatCep(cep) {
    return cep.replace(/[^0-9]/g, "");
  }

  const screenName = useScreenTracking()

  async function handleSubmit(values) {
    const payload = {
      label: values.label,
      streetName: values.streetName,
      neighborhood: values.neighborhood,
      complement: values.complement,
      number: values.number,
      zipCode: formatCep(values.cep),
      city: values.city,
      state: values.state,
      main: values.main === "1" || values.main === true,
      recipient: values.recipient,
      reference: values.reference,
    };

    let  contentType = 'cadastrar-novo-endereco'
    if (address?.uuid) {
      contentType = 'alterar-endereco'
      payload.uuid = address.uuid;
    }

    let status = 'erro';
    try {
      await onConfirm(payload);
      status = 'sucesso';
    } catch (error) {
      status = 'erro';
    }

    trackCallbackMarketplace({
      status,
      contentType,
      screenName: `marketplace-${screenName}`,
    });

    onCancel();
  }

  const handleCancel = () => {
    trackClick({
      title: "cancelar",
      contentType: "cadastrar-novo-endereco",
      screenName,
      tagId: tagIdFromLegacySuffix("07"),
    });
    
    onCancel();
  };

  return (
    <FormAddress
      address={address}
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
    />
  );
}

AddressComponent.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  address: PropTypes.any,
  type: PropTypes.string,
};
